import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchTimeline } from "../../apis/timeline";

import type { JobTimelineData } from "../../utils/types/timeline";

export const fetchTimelineData = createAsyncThunk<
  { data: JobTimelineData[]; total: number; page: number },
  { version?: string; page?: number; pageSize?: number; companyId?: string }
>(
  "timeline/fetchTimelineData",
  async (
    params: {
      version?: string;
      companyId?: string;
      page?: number;
      pageSize?: number;
      startDate?: string;
      endDate?: string;
      agentId?: string;
      q?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const jobsList = await fetchTimeline(params);
      return {
        data: jobsList.data,
        total: jobsList.total,
        page: params.page ?? 1,
      };
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  }
);
